import { Box, Button, Layer, Stack } from 'grommet';
import { Close } from 'grommet-icons';
import styled from 'styled-components';

import { BoxHeading, colors, measures } from '@ThemeMain';

const ModalStyledLayer = styled(Layer)`
  background-color: transparent;
  box-shadow: ${measures.dropShadow} ${colors.dropShadow};
`;

const bodyBottomStyles = {
  withTitle: {
    borderRadius: `0 0 ${measures.borderRadius} ${measures.borderRadius}`,
  },
  withoutTitle: {
    borderRadius: measures.borderRadius,
  },
};

// separated for the sake of showing withtout the layer, in Style Guide
export const ModalInnerBody = (props) => {
  const { onCancel, title } = props;

  const pad = props.pad || 'medium';

  return (
    <Stack anchor="top-right" {...props}>
      <Box>
        {title ? <BoxHeading pad={pad}>{title}</BoxHeading> : null}
        <Box
          pad={pad}
          background="white"
          style={bodyBottomStyles[title ? 'withTitle' : 'withoutTitle']}
        >
          {props.children}
        </Box>
      </Box>
      <Button onClick={onCancel} icon={<Close color="white" />}></Button>
    </Stack>
  );
};

export const ModalBody = (props) => {
  const { onCancel, title } = props;

  return (
    <ModalStyledLayer onEsc={onCancel} onClickOutside={onCancel} {...props}>
      <ModalInnerBody onCancel={onCancel} title={title}>
        {props.children}
      </ModalInnerBody>
    </ModalStyledLayer>
  );
};
